"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@chakra-ui/core");
const ListContext_1 = __importDefault(require("./ListContext"));
exports.ListItem = ({ children, onClick }) => {
    const { actionable } = react_1.useContext(ListContext_1.default);
    return (react_1.default.createElement(core_1.ListItem, { bg: "white", overflow: "hidden", borderTopWidth: "1px", _first: { borderTopWidth: 0 }, onClick: onClick },
        react_1.default.createElement(core_1.PseudoBox, { as: actionable ? 'button' : 'div', transition: "all 0.15s cubic-bezier(.4,0,.2,1)", display: "flex", width: "100%", textAlign: "unset", _hover: actionable ? { backgroundColor: 'gray.50' } : {}, _focus: actionable
                ? {
                    outline: 'none',
                    backgroundColor: 'gray.50',
                }
                : {} },
            react_1.default.createElement(core_1.Box, { px: "4", py: "4", flex: "1", justifyContent: "flex-start" }, children))));
};
